import type { PermissionCode, SessionUser } from '@news-cms/shared';

export function hasPermission(user: SessionUser | null | undefined, code: PermissionCode): boolean {
  return !!user && user.permissions.includes(code);
}

export function canEditPost(
  user: SessionUser | null | undefined,
  post: { authorId: string },
): boolean {
  if (!user) return false;
  if (user.permissions.includes('post.update')) return true;
  return user.permissions.includes('post.update_own') && post.authorId === user.id;
}
